import { computed, ComputedRef } from 'vue'
import { DateTime } from 'luxon'
import { getHalloween } from '@/composables/themes/holidayHelper'

export type UseHalloween = {
  /** Halloween for the current year */
  halloween: DateTime
  /** True if today is Halloween */
  isHalloween: ComputedRef<boolean>
  /**
   * True if today is between 4 weeks before Halloween
   * and 1 week after Halloween
   */
  isWithinHalloweenRange: ComputedRef<boolean>
}

export default function useHalloween(): UseHalloween {
  const now = DateTime.local().startOf('day')
  const halloween = getHalloween(now.year)

  const isHalloween = computed(() => now.hasSame(halloween, 'day'))

  const halloweenStart = halloween.minus({ weeks: 4 })
  const halloweenEnd = halloween.plus({ days: 1 })
  const isWithinHalloweenRange = computed(() => now >= halloweenStart && now <= halloweenEnd)

  return {
    halloween,
    isHalloween,
    isWithinHalloweenRange,
  }
}
